module.exports = __webpack_public_path__ + "static/french-809762b03c36672a741f275d2b500114.jpg";